import { screenNames } from "clientState/AuthFlow/providers/ScreenProvider";

const { SIGNIN } = screenNames;

export const PASSWORDLESS_ID = `${SIGNIN}_click:passwordless`;
export const LOGIN_RESET_PASSWORD_ID = `${SIGNIN}_click:reset_password`;
export const EDO_LOGIN_ERROR_ID = `${SIGNIN}_error:email`;
